import React, { useEffect, useState } from "react";
import api from "../api/axios";
import LedgerForm from "../components/forms/LedgerForm";

function Ledger() {
  const [ledgers, setLedgers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLedger, setSelectedLedger] = useState(null); // For edit
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

  // Fetch groups
  const fetchLedgers = async (pageNumber = 1, searchText = search) => {
    if (searchText && searchText.length < 3) return;
    
    setLoading(true);    
    try {
      const res = await api.get(`/ledger-list?page=${pageNumber}&branch_id=${branch_id}&search=${searchText}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLedgers(res.data.data);
      setPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* useEffect(() => {
    fetchLedgers();
  }, []); */

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchLedgers(1, search);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  // Handle edit click
  const handleEdit = (ledger) => {
    setSelectedLedger(ledger);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" }); // Scroll to form
  };

  // After save/update refresh list
  const handleFormSubmit = () => {
    fetchLedgers(page);
    setSelectedLedger(null);
  };
  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Chart of Accounts</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="#">Accounts</a>
                </li>
                <li className="breadcrumb-item active">Chart of Accounts</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Ledger List */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-2">Account List</h5>

              <input
                type="text"
                className="form-control w-25"
                placeholder="Filter: Name or Code(at least 3 characters).."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  //fetchLedgers(1, e.target.value); // Reset to page 1 when searching
                }}
              />              

            </div>
            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered ledger-table">
                    <thead>
                      <tr>
                        <th>Sl.No.</th>
                        <th>Account Code</th>
                        <th>Account Name</th>
                        <th>Parent Head</th>
                        <th className="text-end">Current Balance</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ledgers.length > 0 ? (
                        ledgers.map((ledger, index) => (
                          <tr key={ledger.id}>
                            <td>{index+1}</td>
                            <td>{ledger.ledger_code}</td>
                            <td>{ledger.ledger_name}</td>
                            <td>{ledger.group.group_name}</td>
                            <td className="text-end">{parseFloat(ledger.current_balance).toFixed(2)}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => handleEdit(ledger)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No ledgers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchLedgers(page - 1)}
                  disabled={page <= 1}
                >
                  Prev
                </button>
                <span>
                  Page {page} of {lastPage}
                </span>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => fetchLedgers(page + 1)}
                  disabled={page >= lastPage}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">
                {selectedLedger ? "Update Account" : "Add New Account"}
              </h4>
            </div>
            <div className="card-body">
              <LedgerForm 
                ledger={selectedLedger}
                onSuccess={handleFormSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Ledger;
